import { SpaceDto } from "@braoshzmvavz/picnube-common";
import {
  Button,
  Divider,
  TextInput,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useForm } from "@mantine/form";
import React from "react";
import { IconType } from "react-icons";

interface SpaceFormValues {
  name: string;
  description: string;
}

export interface SpaceFormProps {
  space?: SpaceDto;
  onSave: (values: SpaceFormValues) => void;
  submitIcon: IconType;
  submitLabel: string;
}

export default function SpaceFormModal(props: SpaceFormProps) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  const form = useForm<SpaceFormValues>({
    initialValues: {
      name: props.space?.name ?? "",
      description: props.space?.description ?? "",
    },
    validate: {
      name: (value) => (value.length < 1 ? "Space name is required" : null),
    },
  });

  const handleSubmit = (values: SpaceFormValues) => {
    props.onSave(values);
  };

  const SubmitIcon = props.submitIcon;

  return (
    <div className="flex flex-col gap-4 w-full p-4">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <div className="flex flex-col gap-4">
          <TextInput
            label="Space Name"
            placeholder="Enter space name"
            {...form.getInputProps("name")}
            required
          />

          <TextInput
            label="Description"
            placeholder="Enter space description"
            {...form.getInputProps("description")}
          />

          <Divider className="my-2" />

          <Button
            className="w-full"
            type="submit"
            leftSection={<SubmitIcon />}
          >
            {props.submitLabel}
          </Button>
        </div>
      </form>
    </div>
  );
} 